import React, { useEffect, useMemo } from 'react';
import styled from 'styled-components';
import { useStaticQuery, graphql } from 'gatsby';
import { RichText } from 'prismic-reactjs';

// Components
import { ButtonHighlight } from '../../button';
import LinkedInSocialIcon from '../../../images/LinkedInSocialLogo.svg';

import { AiFillFacebook } from 'react-icons/ai';

// context
import { useHandleLanguage } from '../../../contexts/language.context';

const ContactWrapper = styled.div`
  position: relative;
  width: 100%;
  margin: auto;
`;

const DetailWrapper = styled.div`
  padding: 142px 114px;
  padding-bottom: 124px;
  display: flex;
  justify-content: space-between;

  @media (max-width: 1112px) {
    padding: 62px 56px;
    display: block;
  }

  @media (max-width: 768px) {
    padding: 62px 24px;
    padding-bottom: 53px;
  }
`;

const AddressWrapper = styled.div``;

const TextWrapper = styled.div`
  @media (min-width: 1024.1px) and (max-width: 1112px) {
    width: 35%;
  }
  @media (max-width: 1024px) {
    margin-left: 45px;
  }
  @media (max-width: 767.9px) {
    margin-left: 0;
  }
`;

const TextWrapperSubHeader = styled.div`
  ${({ theme }) => theme.typography.footerSubHeadline()};
  max-width: 900px;
  width: 100%;

  @media (max-width: 1024px) {
    max-width: 100%;
  }
`;

const CaptionWrapper = styled.div`
  color: ${({ theme }) => theme.color.textBlack};
  line-height: 60px;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    text-align: center;
    margin: 0 0 30px 0;
  }
`;

const TextTitle = styled.div`
  ${({ theme }) => theme.typography.footageDetail()};
  color: ${({ theme }) => theme.color.textRed};
  margin-bottom: 11px;
  width: auto;
`;

const TextAddress = styled.div`
  ${({ theme }) => theme.typography.footerTextContent()};
  color: ${({ theme }) => theme.color.textFooter};
  line-height: 24px;
  margin-bottom: 24px;

  @media (min-width: ${({ theme }) => theme.device.mobileL}) {
    white-space: inherit;
    padding-right: 0;
  }
`;

const TextEmail = styled.div`
  line-height: 24px;
  margin-bottom: 22px;

  ${({ theme }) => theme.typography.footerTextContent()};
  color: ${({ theme }) => theme.color.textFooter};
  background-color: none;
  transition: color 0.1s;

  &:hover {
    color: ${({ theme }) => theme.color.textLinkHover};
  }
`;

const MailTextStyle = styled.a`
  line-height: 24px;
  margin-bottom: 24px;

  ${({ theme }) => theme.typography.footerTextContent()};
  color: ${({ theme }) => theme.color.textFooter};
  background-color: none;
  transition: color 0.1s;
`;
const SocialLink = styled.a``;

const ContentStyle = styled.div`
  width: 617px;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    text-align: left;
    font-size: 36px;
    line-height: 46px;
  }

  @media (max-width: 767.9px) {
    width: 290px;
  }

  @media (min-width: 500px) and (max-width: 700px) and (orientation: landscape) {
    width: 100%;
  }
`;

const IconLabel = styled.div`
  display: flex;
`;
const ContactOnline = styled.div`
  display: flex;
  justify-content: space-evenly;
  width: 100%;

  @media (max-width: 1112px) {
    margin-top: 20px;
    justify-content: space-between;
    padding-right: 85px;
  }

  @media (max-width: 767.9px) {
    display: block;
  }
`;

const IconFacebook = styled(AiFillFacebook)`
  color: #9b9b9b;
  margin: 8px 8px 8px 0;
  width: 22px;
  height: 22px;
`;

const SpecialSocialIcon = styled.img`
  margin: 10px;
  width: 18px;
  height: 18px;
`;

const Contact = (props) => {
  const { lang } = useHandleLanguage();
  const query = useStaticQuery(graphql`
    query {
      allPrismicContact {
        edges {
          node {
            data {
              contact_title {
                raw
              }
              contact_address {
                raw
              }
              contact_description {
                text
              }
              contact_email {
                url
              }
            }
            lang
          }
        }
      }
    }
  `);

  const data = useMemo(() => {
    return query.allPrismicContact.edges.find((edge) => edge.node.lang === lang).node.data;
  }, [query, lang]);

  useEffect(() => {
    const root = document.getElementById('isFooter');

    root.addEventListener('mousemove', (evt) => {
      let x = evt.offsetX / window.innerWidth;
      let y = evt.offsetY / window.innerHeight;
      root.style.setProperty('--mouse-x', x);
      root.style.setProperty('--mouse-y', y);
    });

    root.addEventListener('mouseout', () => {
      root.style.setProperty('--mouse-x', -50);
      root.style.setProperty('--mouse-y', -50);
    });
  }, []);

  return (
    <ContactWrapper>
      <DetailWrapper>
        <TextWrapperSubHeader>
          <CaptionWrapper>
            <ContentStyle>{data.contact_description.text}</ContentStyle>
            <ButtonHighlight
              href="mailto:e.konopka@20scoops.com"
              id="isFooter"
              className="footerBar"
            >
              GET IN TOUCH
            </ButtonHighlight>
          </CaptionWrapper>
        </TextWrapperSubHeader>
        <ContactOnline>
          <AddressWrapper>
            <TextTitle>{RichText.asText(data.contact_title.raw)}</TextTitle>
            <TextAddress>{RichText.render(data.contact_address.raw)}</TextAddress>
          </AddressWrapper>
          <TextWrapper>
            <TextTitle>E-Mail an</TextTitle>
            <TextEmail>
              <MailTextStyle href="mailto:mail@20scoops.com">mail@20scoops.com</MailTextStyle>
            </TextEmail>
            <IconLabel>
              <SocialLink
                href="https://www.facebook.com/20scoopscnx"
                target="_blank"
                rel="nofollow"
              >
                <IconFacebook size={21} />
              </SocialLink>
              <SocialLink
                href="https://www.linkedin.com/company/20scoops-vc/mycompany/?viewAsMember=true"
                target="_blank"
                rel="nofollow"
              >
                <SpecialSocialIcon src={LinkedInSocialIcon} />
              </SocialLink>
            </IconLabel>
          </TextWrapper>
        </ContactOnline>
      </DetailWrapper>
    </ContactWrapper>
  );
};

export default Contact;
